import { MatDialogConfig } from "@angular/material/dialog";

export function getPosManagerPinModalDialogConfig() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '400px';
    dialogConfig.panelClass = ['up-dialog-container', 'manager-auth'];
    return dialogConfig;
}